
























































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { Observable } from 'rxjs';
import { TranslatableField, TranslatableValues } from '@core/interfaces/translatable-field';
import TextEditor from '@shared/components/forms/inputs/text-editor/text-editor.vue';
import BpcInputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';

@Component({
  name: 'bpc-translatable-modal',
  components: {
    'bpc-input-group': BpcInputGroup,
    'bpc-text-editor': TextEditor,
    'bpc-textarea': Textarea,
  },
})
export default class TranslatableModal extends Vue {
  @Prop(String) readonly entityName: string;
  @Prop(Number) readonly entityId: number;

  translatableLanguage: string = null;
  getTranslatableFieldsObservableSubscription = null;
  saveTranslationsObservableSubscription = null;
  translatableFields: TranslatableField[] = null;
  translations: object = null;
  loading: boolean = false;
  missingRequiredFields: boolean = false;

  mounted() {
    // Set the first language to translate if the language of the user is the same as the default one
    if (this.userLang === this.baseLang) {
      this.translatableLanguage = this.languageOptions.find(item => item !== this.userLang);
    } else {
      this.translatableLanguage = this.userLang;
    }
  }

  get config() {
    return {
      id: 'translatable-modal',
      title: this.$t(`global.modals.translatable.${this.entityName}`),
    };
  }

  get baseLang(): string {
    return this.$store.getters['centerSettings/defaultLanguage'];
  }

  get userLang(): string {
    return this.$store.getters['auth/userLang'];
  }

  get availableLanguages() {
    return this.$store.getters['centerSettings/availableLanguages'];
  }

  get languageOptions() {
    return this.availableLanguages.filter(item => item !== this.baseLang);
  }

  checkMissingRequiredFields(): boolean {
    let missing = false;
    // At least, the base language need to be sure set to avoid having empty field when it is required
    this.translatableFields?.forEach(item => {
      if (item.rules.includes('required') && !this.translations[item.fieldName][this.baseLang]) {
        missing = true;
      }
    });
    this.translatableFields?.forEach(item => {
      if (item.rules.includes('required') && !this.translations[item.fieldName][this.userLang]) {
        missing = true;
      }
    });
    return missing;
  }

  onOpenModal() {
    this.getTranslatableFields();
    this.$bvModal.show(this.config.id);
  }
  onCloseModal() {
    this.$bvModal.hide(this.config.id);
    this.translatableFields = null;
    this.translations = null;
    this.$emit('click-on-close');
  }

  getTranslatableFields(): void {
    this.loading = true;
    const path = this.$bpcApiRouteHelper.getTranslatableFieldsPath(this.entityName, this.entityId);
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(path);

    if (this.getTranslatableFieldsObservableSubscription) {
      this.getTranslatableFieldsObservableSubscription.unsubscribe();
    }
    this.getTranslatableFieldsObservableSubscription = observable.subscribe(
      (res: BPCGenericApiResponse<TranslatableField[]>) => {
        this.translations = {};
        this.translatableFields = res.data;
        this.translatableFields.forEach(item => {
          if (Array.isArray(item.values) && item.values.length === 0) {
            this.translations[item.fieldName] = {};
          } else {
            this.translations[item.fieldName] = item.values;
          }
        });
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.$emit('error-getting-translatable-fields');
        this.$bpcMessage.showErrorMessage({
          text: 'global.translations.error_getting_translatable_fields',
        });
      },
    );
  }

  saveTranslations(): void {
    const path = `${this.$bpcApiRouteHelper.getEntityPath(this.entityName)}/${
      this.entityId
    }/translations`;
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.put(path, this.translations);

    if (this.saveTranslationsObservableSubscription) {
      this.saveTranslationsObservableSubscription.unsubscribe();
    }
    this.saveTranslationsObservableSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.$emit('translations-saved');
        this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
      },
      error => {
        this.$bpcMessage.showErrorMessage({ text: 'global.generic.error_form_action' });
        this.$emit('error-saving-translations');
      },
    );
  }

  @Watch('translatableFields', { immediate: true, deep: true })
  onChangeTranslatableFields() {
    this.missingRequiredFields = this.checkMissingRequiredFields();
  }
}
